import { every, isEmpty, some } from 'lodash'

import { TFeature } from './types'
import { useIsDynamicFeatureEnabled } from './use-is-dynamic-feature-enabled'

interface IDynamicFeature {
  name?: TFeature
  anyName?: TFeature[]
  everyName?: TFeature[]
}

interface IDynamicFeatureProps extends IDynamicFeature {
  children?: JSX.Element
}

const DynamicFeature = ({ name, anyName, everyName, children }: IDynamicFeatureProps) => {
  const hasName = useIsDynamicFeatureEnabled(name) || isEmpty(name)
  const hasAnyName = isEmpty(anyName) || some(anyName, useIsDynamicFeatureEnabled)
  const hasEveryName = isEmpty(everyName) || every(everyName, useIsDynamicFeatureEnabled)
  const shouldShow = hasName && hasAnyName && hasEveryName && !!children
  return !shouldShow ? null : children
}

export default DynamicFeature
